import NavBar from "../../Navbar";
import "./ViewApplicants.css";
import React, { useState } from "react";
import { Button, Link, Divider } from "@mui/material";
import ApplicantsCard from "../../ApplicantsCard/ApplicantsCard";
import { useSelector } from "react-redux";

const ViewApplicants = () => {
  const [selectedButton, setSelectedButton] = useState(0);

  const buttons = ["New", "Shortlisted", "Rejected", "All"];

  const handleSelection = (index) => {
    setSelectedButton(index);
  };

  const applicants = useSelector((state) => state.user.applications)
  console.log(applicants,"XXX");

  return (
    <div className="view-applicants">
      <NavBar />
      <div className="applicant-page-canvas">
        <div className="applicant-job-subheading">
          <h5 className="applicant-job-title">Job Title</h5>
          <div className="applicant-details">No of Views:[]</div>
          {buttons.map((label, index) => (
            <div key={index} className="applicant-btn-cntnr">
              <button
                className={
                  selectedButton === index
                    ? "selected-status-btn"
                    : "status-btn"
                }
                onClick={() => handleSelection(index)}
              >
                {label}
              </button>
            </div>
          ))}
          <div className="applicant-analytics">
            <Button variant="outlined">Analytics</Button>
          </div>
          <div className="applicant-sh-link">
            <Link href="/home">Back to home.</Link>
          </div>
        </div>
        <div className="applicant-job-area">
          <div className="applicant-filters">
            <div className="applicant-filter-cntnr">
              <div className="applicant-filter-heading">
                <div className="applicant-filter-title">Filters</div>
                <div className="applicant-filter-count">Applied()</div>
              </div>
              <Divider color="grey" variant="middle" />
              <div className="applicant-filter-exp">
                
              </div>
            </div>
          </div>
          <div className="applicant-list">
            <div className="applicants-cntnr">
              {applicants.map((applicant)=>{
                console.log("Applicant details:", JSON.stringify(applicant));
                return <ApplicantsCard applicantDetails={applicant}></ApplicantsCard>
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewApplicants;
